import { TweenLite } from 'gsap';

const animate = (node, animation, timeInSec, options) => {
	TweenLite[animation](node, timeInSec, options, 1);
};

export default animate;
